import { inject } from 'vue'
import type { Component, InjectionKey, MaybeRefOrGetter } from 'vue'

import type { UiKitMessagesOverride } from '@ui/utils/defaultMessages'

export interface UiKitConfig {
  messages?: MaybeRefOrGetter<UiKitMessagesOverride | undefined>
  linkComponent?: Component
  navigate?: (to: string) => unknown
  imageFallback?: string
}

export const UI_KIT_CONFIG_KEY: InjectionKey<UiKitConfig> = Symbol('ui-kit-config')

export function useUiKitConfig(): UiKitConfig {
  return inject(UI_KIT_CONFIG_KEY, {})
}
